import ProductsList from './Components/ProductsList';
import SideBar from './Components/SideBar';
import CategoryNavigationTree from './Components/CategoryNavigationTree';
import ErrorBoundary from '../../Components/ErrorBoundary/ErrorBoundary';
import { useParams } from '../../Providers/ParamsProvider';

import '../HomePage.css'
import './ShopPageStyle.css'
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.light.css';
import '../../Components/HomePage/products.css'

const ShopPageIndex = () => {
  const { isMobile } = useParams()

  return (
    <>
      <ErrorBoundary>
        <div className='container-fluid'>
          <div className='row justify-content-center'>
            <div className='col-11'>
              <div className='row mt-5 mb-4'>
                <CategoryNavigationTree />
              </div>
              <div className='row justify-content-center '>
                {!isMobile && <SideBar />}
                <ProductsList />
              </div>
            </div>
          </div>
        </div>
      </ErrorBoundary>
    </>
  )
}

export default ShopPageIndex